import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  leaveReportPayload: any;
  permissionTimingInString: {};


  permissionCount: number;
  onDutyCount: number;
}

const initialState: AuthState = {
  leaveReportPayload: {},
  permissionTimingInString: {},
  permissionCount: 0,
  onDutyCount: 0


};

const leaveReportPayloadSlice = createSlice({
  name: 'leaveReportPayload',
  initialState,
  reducers: {
    setLeaveReportPayload: (state, action: PayloadAction<any>) => {
      state.leaveReportPayload = action.payload;
    },
    clearLeaveReportPayload: state => {
      state.leaveReportPayload = {};
    },
    setPermissionTimingInString: (state, action: PayloadAction<any>) => {
      state.permissionTimingInString = action.payload;
    },


    setPermissionCount: (state, action: PayloadAction<number>) => {
      state.permissionCount = action.payload;
    },
    clearPermissionCount: state => {
      state.leaveReportPayload = {};
    },
    setOnDutyCount: (state, action: PayloadAction<number>) => {
      state.onDutyCount = action.payload;
    },
    clearOnDutyCount: state => {
      state.leaveReportPayload = {};
    },
  }
});

export const { setLeaveReportPayload, clearLeaveReportPayload, setPermissionTimingInString, setPermissionCount, clearPermissionCount, setOnDutyCount, clearOnDutyCount } = leaveReportPayloadSlice.actions;
export default leaveReportPayloadSlice.reducer;